// extracted by css-extract-rspack-plugin
export default {"quantityText":"product-detail-fragment__DeliveryFormatQuantity_quantityText__iDQWa"};